export default {
  en: {
    settings: {
      sidenav: {
        settings: 'Settings',
        profile: 'Profile',
        account: 'Account',
        notifications: 'Notifications',
        affiliates: 'Affiliates',
        methods: 'Payment Methods',
        subscriptions: 'Subscriptions',
        theme: 'Theme',
        flightschool: 'Flight School',
      },
      flightschool: {
        heading: 'Flight School',
        nomember: {
          text: 'You are not a member of the Flight School. You may either create a new flight school or join an existing one.',
          create: 'Create Flight School',
          join: 'Join Flight School',
        },
        onlymember: {
          text: 'You are a member of the Flight School {name}. You can leave the flight school if you no longer wish to be a member.',
          leave: 'Leave Flight School',
          requestleave: 'If you really want to leave, please confirm below',
          confirmleavebutton: 'Confirm leave',
        },
        owner: {
          text: 'You are the owner of the Flight School {name}. You can delete the flight school if you no longer wish to have it.',
          disband: 'Disband Flight School',
          requestdisband: 'If you really want to disband, please confirm below',
          confirmdisbandbutton: 'Confirm disband',
        }
      }
    }
  },
  es: {
    settings: {
      sidenav: {
        settings: 'Configuración',
        profile: 'Perfil',
        account: 'Cuenta',
        notifications: 'Notificaciones',
        affiliates: 'Afiliados',
        methods: 'Métodos de Pago',
        subscriptions: 'Suscripciones',
        theme: 'Tema',
        flightschool: 'Escuela de Vuelo',
      },
      flightschool: {
        heading: 'Escuela de Vuelo',
        nomember: {
          text: 'No eres miembro de una Escuela de Vuelo. Puedes crear una nueva escuela de vuelo o unirte a una existente.',
          create: 'Crear Escuela de Vuelo',
          join: 'Unirse a una Escuela de Vuelo',
        },
        onlymember: {
          text: 'Eres miembro de la Escuela de Vuelo {name}. Puedes abandonar la escuela de vuelo si ya no deseas ser miembro.',
          leave: 'Abandonar Escuela de Vuelo',
          requestleave: 'Si realmente deseas abandonar, por favor confirma abajo',
          confirmleavebutton: 'Confirmar abandono',
        },
        owner: {
          text: 'Eres el propietario de la Escuela de Vuelo {name}. Puedes eliminar la escuela de vuelo si ya no deseas tenerla.',
          disband: 'Disolver Escuela de Vuelo',
          requestdisband: 'Si realmente deseas disolver, por favor confirma abajo',
          confirmdisbandbutton: 'Confirmar disolución',
        }
      }
    }
  },
  de: {
    settings: {
      sidenav: {
        settings: 'Einstellungen',
        profile: 'Profil',
        account: 'Konto',
        notifications: 'Benachrichtigungen',
        affiliates: 'Affiliates',
        methods: 'Zahlungsmethoden',
        subscriptions: 'Abonnements',
        theme: 'Thema',
        flightschool: 'Flugschule',
      },
      flightschool: {
        heading: 'Flugschule',
        nomember: {
          text: 'Du bist kein Mitglied einer Flugschule. Du kannst entweder eine neue Flugschule erstellen oder einer bestehenden beitreten.',
          create: 'Flugschule erstellen',
          join: 'Flugschule beitreten',
        },
        onlymember: {
          text: 'Du bist Mitglied der Flugschule {name}. Du kannst die Flugschule verlassen, wenn du kein Mitglied mehr sein möchtest.',
          leave: 'Flugschule verlassen',
          requestleave: 'Wenn du die Flugschule wirklich verlassen möchtest, bestätige bitte unten',
          confirmleavebutton: 'Verlassen bestätigen',
        },
        owner: {
          text: 'Du bist der Inhaber der Flugschule {name}. Du kannst die Flugschule löschen, wenn du sie nicht mehr haben möchtest.',
          disband: 'Flugschule auflösen',
          requestdisband: 'Wenn du die Flugschule wirklich auflösen möchtest, bestätige bitte unten',
          confirmdisbandbutton: 'Auflösung bestätigen',
        }
      }
    }
  },
  uk:{
    settings: {
      sidenav: {
        settings: 'Налаштування',
        profile: 'Профіль',
        account: 'Акаунт',
        notifications: 'Сповіщення',
        affiliates: 'Партнери',
        methods: 'Способи оплати',
        subscriptions: 'Підписки',
        theme: 'Тема',
        flightschool: 'Льотна школа',
      },
      flightschool: {
        heading: 'Льотна школа',
        nomember: {
          text: 'Ви не є членом льотної школи. Ви можете створити нову льотну школу або приєднатися до існуючої.',
          create: 'Створити льотну школу',
          join: 'Приєднатися до льотної школи',
        },
        onlymember: {
          text: 'Ви є членом льотної школи {name}. Ви можете покинути льотну школу, якщо більше не бажаєте бути її членом.',
          leave: 'Покинути льотну школу',
          requestleave: 'Якщо ви дійсно хочете покинути, будь ласка, підтвердіть нижче',
          confirmleavebutton: 'Підтвердити вихід',
        },
        owner: {
          text: 'Ви є власником льотної школи {name}. Ви можете видалити льотну школу, якщо більше не бажаєте її мати.',
          disband: 'Розпустити льотну школу',
          requestdisband: 'Якщо ви дійсно хочете розпустити, будь ласка, підтвердіть нижче',
          confirmdisbandbutton: 'Підтвердити розпуск',
        }
      }
    }
  }
}
